import { render, staticRenderFns } from "./DropdownItems.vue?vue&type=template&id=cd0feda2&scoped=true"
import script from "./DropdownItems.vue?vue&type=script&lang=js"
export * from "./DropdownItems.vue?vue&type=script&lang=js"
import style0 from "./DropdownItems.vue?vue&type=style&index=0&id=cd0feda2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd0feda2",
  null
  
)

export default component.exports